import { Select } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const StyledSelect = styled(Select)<{ error?: boolean; maxWidth?: string }>`
  height: ${rem(56)};
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : rem(360))};
  width: -webkit-fill-available;
  border-top-left-radius: ${rem(12)};
  border-top-right-radius: ${rem(12)};
  border-bottom-left-radius: 0;
  padding-top: ${rem(20)};
  border-bottom-right-radius: 0;
  border-color: ${({ theme, error }) => error && theme.color.piccolo};
  color: ${({ theme }) => theme.color.bulma[100]};
  outline-color: ${({ theme }) => theme.color.piccolo[100]};
`;
export default StyledSelect;
